import {logger} from 'tizra'
import * as B from '../block'
import {ImageBlockConfig} from './meta'

const log = logger('ImageBlock/Simple')

interface SimpleProps {
  imageUrl: string
  altText: string
  setErrored: (url: string) => void
  linkUrl: string
  surround: ImageBlockConfig['surround']
}

export const Simple = ({
  imageUrl,
  altText,
  setErrored,
  linkUrl,
  surround,
}: SimpleProps) => {
  let image = (
    <B.Image
      src={imageUrl}
      alt={altText}
      fluid
      onError={() => setErrored(imageUrl)}
      shadowed={surround === 'shadow'}
      {...B.tid('ImageBlock-img')}
    />
  )

  if (linkUrl) {
    image = (
      <B.UniversalLink
        href={linkUrl}
        {...B.tid('ImageBlock-link')}
        style={{display: 'block'}}
      >
        {image}
      </B.UniversalLink>
    )
  }

  return image
}
